import { EMAIL_PATTERN, INTEGER_PATTERN, NUMBER_PATTERN } from '@/utils/constant'
import { useValidationMessages } from '@/utils/messages'
import { FormInputs } from '@/types/field'

export const useInputValidator = () => {
    const ValidationMessages = useValidationMessages()
    return {
        password: {
            required: ValidationMessages.password.required
        },
        email: {
            required: ValidationMessages.email.required,
            pattern: {
                value: EMAIL_PATTERN,
                message: ValidationMessages.email.invalid
            }
        },
        confirmPassword: {
            required: ValidationMessages.confirmPassword.required,
            is_validate: (value: string, context: FormInputs) => {
                if (value !== context.password) {
                    return ValidationMessages.password.match
                }
            }
        },
        name: {
            required: ValidationMessages.name.required
        },
        fname: {
            required: ValidationMessages.fname.required
        },
        lname: {
            required: ValidationMessages.lname.required
        },
        newPassword: {
            required: ValidationMessages.password.required
        },
        currentPassword: {
            required: ValidationMessages.currentPassword.required
        },
        linkedin_cookie: {
            required: ValidationMessages.linkedin_cookie.required,
            validate: {
                isJsonArray: (value: string) => {
                    try {
                        const parsed = JSON.parse(value)
                        if (!Array.isArray(parsed)) return 'Input must be a JSON array'
                        if (!parsed.length) return 'Input must be a JSON array of object'
                        if (!parsed.every(item => typeof item === 'object' && item !== null && !Array.isArray(item))) {
                            return 'Each item must be an object'
                        }
                        return true
                    } catch {
                        return 'Invalid JSON Array format'
                    }
                }
            }
        },
        title: {
            required: ValidationMessages.title.required
        },
        interval: {
            required: ValidationMessages.interval.required
        },
        amount: {
            required: ValidationMessages.amount.required,
            pattern: {
                value: NUMBER_PATTERN,
                message: ValidationMessages.amount.invalid
            },
            is_validate: (value: string) => {
                return parseFloat(value) > 0 || 'Amount must be greater than 0'
            }
        },
        price_id: {
            required: ValidationMessages.price_id.required
        },
        threshold_score: {
            required: ValidationMessages.threshold_score.required,
            pattern: {
                value: NUMBER_PATTERN,
                message: ValidationMessages.threshold_score.invalid
            },
            is_validate: (value: string) => {
                return parseInt(value) > 0 || 'Threshold score must be greater than 0'
            }
        },
        type: {
            required: ValidationMessages.type.required
        },
        number_of_scans: {
            required: ValidationMessages.number_of_scans.required,
            pattern: {
                value: INTEGER_PATTERN,
                message: ValidationMessages.number_of_scans.invalid
            },
            is_validate: (value: string) => {
                const num = parseInt(value, 10)
                return num > 0 || 'Number of scans must be greater than 0'
            }
        },
        seq: {
            required: ValidationMessages.seq.required
        },
        linkedIn_score: {
            required: ValidationMessages.linkedIn_score.required,
            pattern: {
                value: NUMBER_PATTERN,
                message: ValidationMessages.linkedIn_score.invalid
            },
            is_validate: (value: string) => {
                return parseInt(value) > 0 || 'Threshold score must be greater than 0'
            }
        },
        free_trial_scans: {
            required: ValidationMessages.free_trial_scans.required,
            pattern: {
                value: INTEGER_PATTERN,
                message: 'Invalid number of scans'
            },
            is_validate: (value: string) => {
                return parseInt(value) > 0 || 'Number of scans must be greater than 0'
            }
        },
        number_of_days: {
            required: ValidationMessages.number_of_days.required,
            pattern: {
                value: INTEGER_PATTERN,
                message: 'Invalid number of days'
            },
            is_validate: (value: string) => {
                return parseInt(value) > 0 || 'Number of days must be greater than 0'
            }
        }
    }
}
